import React from 'react';
import { Mouvement } from '@mairistem/comptabilite';
import DelaiPaiementComponent from '../../../components/Mouvement/Panel/DelaiPaiementComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import MouvementPanel from './MouvementPanel';

class DelaiPaiementPanel extends MouvementPanel {
  constructor(isMandatory = false) {
    super(isMandatory);
    this.code = CODE_PANEL.DELAI_PAIEMENT;
    this.defaultSize = 6;
    this.icon = { name: 'clock' };
  }

  getLibelle = () => 'Délai global de paiement';

  isEmpty = (data: Mouvement) => !data?.dureeDelaiGlobalPaiement && !data?.dateDepartDelaiGlobalPaiement && !data?.dateFinDelaiGlobalPaiement;

  getComponent = function getComponent(
    data: any,
    onChange: any,
    handlePin: any,
  ): React.ReactElement {
    return (
      <DelaiPaiementComponent
        data={data}
        handlePin={handlePin}
        onChange={onChange}
        panel={this}
      />
    );
  };
}

export default DelaiPaiementPanel;
